// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrow-container {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  padding: 3px 0px 0px 2px;
  border: 1px solid #8b0096;
}
.arrow-container:hover {
  border: 1px solid #29bb73;
}

.arrow-container-lfp {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  padding: 3px 0px 0px 2px;
  border: 1px solid #085FFF;
}
.arrow-container-lfp:hover {
  border: 1px solid #FF7FDE;
}

.title-text {
  color: #3e0d42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.subtitle-text {
  color: #6b556c;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.notes-area {
  height: 160px;
}

.request-wrapper {
  padding-top: 16px;
  background-color: white;
  margin-bottom: 64px;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
}
.request-wrapper .header {
  margin-top: 15px;
  padding-bottom: 15px;
}
.request-wrapper .title-text {
  color: #3e0d42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .subtitle-text {
  color: #6b556c;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ededed;
}
@media (min-width: 768px) {
  .request-wrapper .section-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  .request-wrapper .section-wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.request-wrapper .section-wrapper .title-wr {
  margin-top: 8px;
  margin-bottom: 10px;
}
.request-wrapper .section-wrapper .title-wr .title-text {
  color: #3e0d42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .form-check-label {
  opacity: 0.8;
  color: #382738;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .details-wrapper {
  margin-top: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  background-color: #fcfcfc;
}
.request-wrapper .section-wrapper .details-wrapper .title {
  color: #3e0d42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}
.request-wrapper .section-wrapper .details-wrapper .subtitle {
  color: #6b556c;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.request-wrapper .section-wrapper .details-wrapper .action-text {
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.75px;
  line-height: 14px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper {
  border: 1px solid lightgray;
  margin-bottom: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3e0d42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}
.request-wrapper .request-footer {
  margin-top: 22px;
}
.request-wrapper .request-footer .btn {
  height: 30px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}
.request-wrapper .request-footer .btn-outline-dark {
  color: #382738;
  border: 1px solid #ebe9eb;
  background-color: #ffffff;
}
.request-wrapper .additional-notes {
  color: #3e0d42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
  margin-bottom: 5px;
}
.request-wrapper .notes-area {
  border: 1px solid #ebe9eb;
  border-radius: 3px;
  background-color: #fcfcfc;
  width: 100%;
  height: 160px;
}
.request-wrapper .accordion-wrapper .header-row {
  padding: 10px 0;
}
.request-wrapper .accordion-wrapper .broadcaster-name {
  color: white;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .accordion-wrapper .request-date {
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}
.request-wrapper .accordion-wrapper .request-status {
  text-transform: uppercase;
  color: black;
}

.half-opacity {
  opacity: 0.5;
}

.btn-outline-blue {
  color: #085FFF !important;
  border: 1px solid #085FFF !important;
  background-color: #ffffff;
  text-transform: uppercase;
}
.btn-outline-blue:hover {
  background-color: #085FFF !important;
  border: 1px solid #085FFF !important;
  color: #ffffff !important;
}

.back-to-list {
  position: absolute;
  top: 10px;
  left: 30px;
  z-index: 40;
  text-transform: uppercase;
}

.broadcasters-req-header {
  background-color: black;
}

.status-approved {
  display: flex;
  justify-content: center;
  border-radius: 2px;
  min-width: 130px;
  padding: 5px 20px;
  background-color: #DAF2B7;
  border: 1px solid #83D510;
}

.status-submitted {
  display: flex;
  justify-content: center;
  border-radius: 2px;
  min-width: 130px;
  padding: 5px 20px;
  background-color: #FADDB3;
  border: 1px solid #ED8E00;
}

.status-rejected {
  display: flex;
  justify-content: center;
  border-radius: 2px;
  min-width: 130px;
  padding: 5px 20px;
  background-color: #FBCCD2;
  border: 1px solid #ED001C;
}

.gray {
  color: white !important;
  background-color: #585857;
}`, "",{"version":3,"sources":["webpack://./src/app/components/club-interview-details/club-interview-league/club-interview-league.component.scss","webpack://./src/styles/global/_colors.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;AADJ;;AAIA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;AADJ;;AAKA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAFF;AAIE;EACE,gBAAA;EACA,oBAAA;AAFJ;AAME;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AALJ;AAQE;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AANJ;AAQI;EALF;IAMI,iBAAA;IACA,oBAAA;EALJ;AACF;AAOI;EAVF;IAWI,iBAAA;IACA,oBAAA;EAJJ;AACF;AAMI;EACE,eAAA;EACA,mBAAA;AAJN;AAMM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAJR;AAQI;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AANN;AASI;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAPN;AASM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAPR;AAUM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AARR;AAWM;EACE,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAVR;AAaM;EACE,2BAAA;EACA,mBAAA;AAXR;AAaQ;EACE,YAAA;AAXV;AAcQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAZV;AAeQ;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAbV;AAmBE;EACE,gBAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAjBN;AAoBI;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAlBN;AAsBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AArBJ;AAyBI;EACE,eAAA;AAvBN;AA0BI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAxBN;AA2BI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAzBN;AA4BI;EACE,yBAAA;EACA,YAAA;AA1BN;;AA+BA;EACE,YAAA;AA5BF;;AA8BA;EACE,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,yBAAA;AA3BF;AA6BE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AA3BJ;;AA+BA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AA5BF;;AA8BA;EACE,uBAAA;AA3BF;;AAsCA;EAPE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAKA,yBChQwB;EDiQxB,yBAAA;AA/BF;;AAkCA;EAbE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAWA,yBCxQyB;EDyQzB,yBAAA;AA3BF;;AA8BA;EAnBE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAiBA,yBC1QwB;ED2QxB,yBAAA;AAvBF;;AAyBA;EACE,uBAAA;EACA,yBCvRgB;ADiQlB","sourcesContent":["@import \"../../../../styles/global/colors\";\n\n.arrow-container {\n  height: 30px;\n  width: 30px;\n  border-radius: 15px;\n  padding: 3px 0px 0px 2px;\n  border: 1px solid #8b0096;\n\n  &:hover {\n    border: 1px solid #29bb73;\n  }\n}\n.arrow-container-lfp {\n  height: 30px;\n  width: 30px;\n  border-radius: 15px;\n  padding: 3px 0px 0px 2px;\n  border: 1px solid $interviews-blue;\n\n  &:hover {\n    border: 1px solid $interviews-pink;\n  }\n}\n\n.title-text {\n  color: #3e0d42;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n}\n\n.subtitle-text {\n  color: #6b556c;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n}\n\n.notes-area {\n  height: 160px;\n}\n\n.request-wrapper {\n  padding-top: 16px;\n  background-color: white;\n  margin-bottom: 64px;\n  border-top: 1px solid #ededed;\n  border-bottom: 1px solid #ededed;\n\n  .header {\n    margin-top: 15px;\n    padding-bottom: 15px;\n    // border-bottom: 1px solid #EDEDED;\n  }\n\n  .title-text {\n    color: #3e0d42;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .subtitle-text {\n    color: #6b556c;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .section-wrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #ededed;\n\n    @media (min-width: 768px) {\n      padding-top: 30px;\n      padding-bottom: 30px;\n    }\n\n    @media (min-width: 1024px) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n\n    .title-wr {\n      margin-top: 8px;\n      margin-bottom: 10px;\n\n      .title-text {\n        color: #3e0d42;\n        font-size: 14px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 18px;\n      }\n    }\n\n    .form-check-label {\n      opacity: 0.8;\n      color: #382738;\n      font-size: 13px;\n      font-weight: bold;\n      letter-spacing: 0.46px;\n      line-height: 18px;\n    }\n\n    .details-wrapper {\n      margin-top: 16px;\n      padding: 20px 0;\n      border-bottom: 1px solid #ededed;\n      border-top: 1px solid #ededed;\n      background-color: #fcfcfc;\n\n      .title {\n        color: #3e0d42;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.39px;\n        line-height: 15px;\n      }\n\n      .subtitle {\n        color: #6b556c;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.69px;\n        line-height: 22px;\n      }\n\n      .action-text {\n        margin-left: 12px;\n        // color: #29BB73;\n        font-size: 12px;\n        font-weight: bold;\n        letter-spacing: 0.75px;\n        line-height: 14px;\n      }\n\n      .item-wrapper {\n        border: 1px solid lightgray;\n        margin-bottom: 16px;\n\n        .item {\n          margin: 12px;\n        }\n\n        .item-name {\n          color: #3e0d42;\n          font-size: 13px;\n          font-weight: bold;\n          letter-spacing: 0.5px;\n          line-height: 16px;\n        }\n\n        .item-info {\n          opacity: 0.8;\n          color: #382738;\n          font-size: 11px;\n          letter-spacing: 0.55px;\n          line-height: 18px;\n        }\n      }\n    }\n  }\n\n  .request-footer {\n    margin-top: 22px;\n\n    .btn {\n      height: 30px;\n      border-radius: 3px;\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .btn-outline-dark {\n      color: #382738;\n      border: 1px solid #ebe9eb;\n      background-color: #ffffff;\n    }\n  }\n\n  .additional-notes {\n    color: #3e0d42;\n    font-size: 11px;\n    font-weight: bold;\n    letter-spacing: 0.39px;\n    line-height: 15px;\n    margin-bottom: 5px;\n  }\n\n  .notes-area {\n    border: 1px solid #ebe9eb;\n    border-radius: 3px;\n    background-color: #fcfcfc;\n    width: 100%;\n    height: 160px;\n  }\n\n  .accordion-wrapper {\n    .header-row {\n      padding: 10px 0;\n    }\n\n    .broadcaster-name {\n      color: white;\n      font-size: 14px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 18px;\n    }\n\n    .request-date {\n      color: #382738;\n      font-size: 11px;\n      letter-spacing: 0.55px;\n      line-height: 18px;\n    }\n\n    .request-status {\n      text-transform: uppercase;\n      color: black;\n    }\n  }\n}\n\n.half-opacity {\n  opacity: 0.5;\n}\n.btn-outline-blue {\n  color: $interviews-blue !important;\n  border: 1px solid $interviews-blue !important;\n  background-color: #ffffff;\n  text-transform: uppercase;\n\n  &:hover {\n    background-color: $interviews-blue !important;\n    border: 1px solid $interviews-blue !important;\n    color: #ffffff !important;\n  }\n}\n\n.back-to-list {\n  position: absolute;\n  top: 10px;\n  left: 30px;\n  z-index: 40;\n  text-transform: uppercase;\n}\n.broadcasters-req-header {\n  background-color: black;\n}\n\n@mixin status-block {\n  display: flex;\n  justify-content: center;\n  border-radius: 2px;\n  min-width: 130px;\n  padding: 5px 20px;\n}\n\n.status-approved {\n  @include status-block;\n  background-color: $interviews-btn-approved;\n  border: 1px solid $interviews-btn-approved-outline;\n}\n\n.status-submitted {\n  @include status-block;\n  background-color: $interviews-btn-submitted;\n  border: 1px solid $interviews-btn-submitted-outline;\n}\n\n.status-rejected {\n  @include status-block;\n  background-color: $interviews-btn-rejected;\n  border: 1px solid $interviews-btn-rejected-outline;\n}\n.gray {\n  color: white !important;\n  background-color: $interviews-gray;\n}\n","$interviews-light-gray: #E0E0E0;\n$interviews-alt-light-gray: #ECECEC;\n$interviews-table-gray: #F5F5F5;\n$interviews-dark-gray: #262624;\n$interviews-gray: #585857;\n$interviews-blue: #085FFF;\n$interviews-scroll-blue: #b4ceff;\n$interviews-pink: #FF7FDE; \n$interviews-btn-submitted: #FADDB3;\n$interviews-btn-submitted-outline: #ED8E00;\n$interviews-btn-approved: #DAF2B7;\n$interviews-btn-approved-outline: #83D510;\n$interviews-btn-rejected: #FBCCD2;\n$interviews-btn-rejected-outline: #ED001C;\n$interviews-btn-draft: rgb(148, 148, 141);\n$interviews-btn-draft-outline: rgb(57, 57, 57);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
